console.log('✅ select-language-top.js loaded successfully!');

// Efficient top-level imports for frequently used core modules
import { APP_CONFIG } from '../../js/config.js';
import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';
import { appState, setAppStateValueByKey, getArrowToggleDownIconSVG } from '../../js/state.js';
import { updateLanguageInURL } from '../../js/router.js';

import { loadTextTranslations } from '../../js/translator.js';
import { initLinksTranslator } from '../../js/router-routes-manager.js';

let _tempTextTranslator = null;
export async function initTempTextTranslator(lang) {
  _tempTextTranslator = await loadTextTranslations(lang);
}

let _tempLinksTranslator = null;
export async function initTempLinksTranslator(lang) {
  _tempLinksTranslator = await initLinksTranslator(lang);
}

//const lang = appState.SiteLanguageCookie;

export async function buildComponentSelectLanguageTop() {
  console.log(`🔄 Building Component: SelectLanguageTop - lang: ${appState.SiteLanguageCookie}`);

  try {
    //await initTempTextTranslator(lang);
    //await initTempLinksTranslator(lang);

    //const {
    //    keyFindManufacturerByCategories: lblFindManufacturerByCategories,

    //} = _tempTextTranslator;

    //const {
    //    keySubcategories: linkSubcategories,

    //}
    //    = _tempLinksTranslator;

    // <img src="${languageIcon}" class="new-language-globe-icon" width="20" height="20" alt="Select Language" />
    // <img src="${dropdownIcon}" class="new-language-dropdown-icon" width="20" height="20" />
    // const downIconSVG = getArrowToggleDownIconSVG("new-language-dropdown-icon", 20);

    // Get language label from code
    const getLanguageLabel = code => {
      const lang = APP_CONFIG.VALID_LANGUAGES.find(lang => lang.code === code);
      return lang ? lang.name : 'English (UK)';
    };

    const languageLabel = getLanguageLabel(appState.SiteLanguageCookie);
    const imgSrcForIcons = `${APP_CONFIG.IMAGES_BASE_URL}imgs/icons/svg/`;
    const languageIcon = `${imgSrcForIcons}language11.svg`;
    const dropdownIcon = `${imgSrcForIcons}arrow-toggle-down.svg`;

    // Generate language options dynamically
    const optionsHTML = APP_CONFIG.VALID_LANGUAGES.map(
      lang =>
        `<option class="dropbtnSelectSiteLanguage-content-label" value="${lang.code}">${lang.name}</option>`
    ).join('');

    // Generate the HTML structure
    const html = `
            <div class="divTopLanguageWrapper" tabindex="0">
                <div class="divTopLanguageWrapper-Button">
                    <button id="btnSelectLanguage" class="button" title="Select Language">
                        <div class="new-language-container">
                                               

                        <svg viewBox="0 0 24 24" class="new-language-globe-icon" width="20" height="20" role="img" xmlns="http://www.w3.org/2000/svg" aria-labelledby="languageIconTitle" stroke="#000000" stroke-width="1" stroke-linecap="square" stroke-linejoin="miter" fill="none" color="#000000">
      <title id="languageIconTitle">Language</title>
      <circle cx="12" cy="12" r="10"/>
      <path stroke-linecap="round" d="M12,22 C14.6666667,19.5757576 16,16.2424242 16,12 C16,7.75757576 14.6666667,4.42424242 12,2 C9.33333333,4.42424242 8,7.75757576 8,12 C8,16.2424242 9.33333333,19.5757576 12,22 Z"/>
      <path stroke-linecap="round" d="M2.5 9L21.5 9M2.5 15L21.5 15"/>
    </svg>                    
 


                            <div class="new-language-label">${languageLabel}</div>
                          <svg fill="#555" height="20px" width="20px" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="new-language-dropdown-icon">
      <path d="M13.708 6.29A1.006 1.006 0 0 0 13 6H5.005A1 1 0 0 0 4.3 7.71l4 4a1.013 1.013 0 0 0 1.42 0l4-4a1.01 1.01 0 0 0-.013-1.42z"></path>
    </svg>
                        </div>
                    </button>
                </div>
                <div id="dropDownSelectSiteLanguage" class="dropbtnSelectSiteLanguage-content" style="display: none;">
                    ${optionsHTML}
                </div>
            </div>`;

    console.log('✅ SelectLanguageTop built successfully.');

    // Register the event listener only when the component is built
    registerEventListenerToAttach(async () => initComponentSelectLanguageTop());

    return html;
  } catch (err) {
    console.error('❌ Error building SelectLanguageTop:', err);
    return '<div>Error loading language selector</div>';
  }
}

export async function initComponentSelectLanguageTop() {
  try {
    const languageButton = document.querySelector('#btnSelectLanguage');
    const dropdown = document.querySelector('#dropDownSelectSiteLanguage');
    if (!languageButton || !dropdown) return;

    let isDropdownOpen = false;

    const toggleDropdown = () => {
      isDropdownOpen = !isDropdownOpen;
      dropdown.style.display = isDropdownOpen ? 'block' : 'none';
    };

    const closeDropdown = () => {
      isDropdownOpen = false;
      dropdown.style.display = 'none';
    };

    const onLanguageButtonClick = () => toggleDropdown();

    const onDropdownClick = async event => {
      const newLang = event.target.value;
      if (newLang) {
        await applyLanguageChange(newLang);
      }
    };

    const onOutsideClick = event => {
      if (!languageButton.contains(event.target) && !dropdown.contains(event.target)) {
        closeDropdown();
      }
    };

    // Safely remove and reattach listeners
    languageButton.removeEventListener('click', onLanguageButtonClick);
    languageButton.addEventListener('click', onLanguageButtonClick);

    dropdown.removeEventListener('click', onDropdownClick);
    dropdown.addEventListener('click', onDropdownClick);

    document.removeEventListener('click', onOutsideClick);
    document.addEventListener('click', onOutsideClick);

    console.log('✅ SelectLanguageTop event listeners attached.');
  } catch (error) {
    console.error('❌ Error attaching event listeners to SelectLanguageTop:', error);
  }
}

//export async function initComponentSelectLanguageTop() {

//    try {

//       // alert("initbuildComponentSelectLanguageTop");

//       // await setupCloseBtnButtonListeners();

//        const languageButton = document.querySelector("#btnSelectLanguage");
//        const dropdown = document.querySelector("#dropDownSelectSiteLanguage");
//        let isDropdownOpen = false;

//        const toggleDropdown = () => {

//            isDropdownOpen = !isDropdownOpen;
//            dropdown.style.display = isDropdownOpen ? "block" : "none";
//        };

//        const closeDropdown = () => {
//            isDropdownOpen = false;
//            dropdown.style.display = "none";
//        };

//        // Toggle dropdown on button click
//        languageButton?.addEventListener("click", () => toggleDropdown());

//                      // Listen for language selection from dropdown
//                dropdown?.addEventListener("click", async (event) => {
//                    const newLang = event.target.value;

//                    if (newLang) {
//                        await applyLanguageChange(newLang);
//                    }
//                });

//        // Close dropdown when clicking outside
//        document.addEventListener("click", (event) => {
//            if (!languageButton.contains(event.target) && !dropdown.contains(event.target)) {
//                closeDropdown();
//            }
//        });

//        console.log("✅ SelectLanguageTop event listeners attached.");
//    } catch (error) {
//        console.error("❌ Error attaching event listeners to SelectLanguageTop:", error);
//    }
//}

//async function setupContinueShoppingButtonListeners() {

//    const continueShoppingBtn = document.getElementById("btnContinueShopping");
//    if (continueShoppingBtn) {
//        const clone = continueShoppingBtn.cloneNode(true);
//        continueShoppingBtn.parentNode.replaceChild(clone, continueShoppingBtn);
//        addListenerViaCurrentlyAttachedListenersRegistry(clone, "click", async () => {
//            await handleResetForm();
//        });
//    }

//}

//async function setupCloseBtnButtonListeners() {
//    const closeBtn = document.getElementById("btnCloseNewsletterWide");
//    if (closeBtn) {
//        const clone = closeBtn.cloneNode(true);
//        closeBtn.parentNode.replaceChild(clone, closeBtn);
//        addListenerViaCurrentlyAttachedListenersRegistry(clone, "click", async () => {
//            await handleResetForm();
//        });
//    }
//}

async function applyLanguageChange(newLang) {
  try {
    // Update language in URL and reload the page
    await updateLanguageInURL(newLang);

    //  // Update internal state and save to appState
    //  setAppStateValueByKey("SiteLanguageCookie", newLang);

    // Update the language label in the UI
    const languageLabel = document.querySelector('.new-language-label');

    if (languageLabel) {
      const newLanguageLabel = await getLanguageLabel(newLang);
      languageLabel.textContent = newLanguageLabel;
    }

    console.log(`🌐 Language changed to: ${newLang}`);
  } catch (err) {
    console.error('❌ Error updating language:', err);
  }
}

async function getLanguageLabel(code) {
  const lang = APP_CONFIG.VALID_LANGUAGES.find(lang => lang.code === code);
  return lang ? lang.name : 'English (UK)';
}
